import React from 'react';
import { Container, Paper, Typography, Button, Box } from '@mui/material';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import Storefront from '@mui/icons-material/Storefront';
import Home from '@mui/icons-material/Home';
import Receipt from '@mui/icons-material/Receipt';
import { useNavigate, useLocation } from 'react-router-dom';

const OrderSuccess: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const orderNumber = location.state?.orderId || `ORD-${Math.floor(100000 + Math.random() * 900000)}`;

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper elevation={3} sx={{ p: 5, textAlign: 'center', borderRadius: 4 }}>
        <CheckCircleOutline color="success" sx={{ fontSize: 80, mb: 2 }} />
        <Typography variant="h4" gutterBottom fontWeight="bold">
          Order Placed Successfully!
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" paragraph>
          Thank you for your purchase. Your order number is <strong>{orderNumber}</strong>.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          We have sent a confirmation email to your registered email address.
          You can track your order status in your dashboard.
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Button
            variant="contained"
            size="large"
            startIcon={<Storefront />}
            onClick={() => navigate('/marketplace')}
          >
            Continue Shopping
          </Button>
          <Button
            variant="outlined"
            size="large"
            startIcon={<Receipt />}
            onClick={() => navigate('/account')}
          >
            View My Orders
          </Button>
          <Button
            variant="text"
            size="large"
            startIcon={<Home />}
            onClick={() => navigate('/')}
          >
            Back to Home
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default OrderSuccess;
